<template>
    <master-page>
        <br/>
        <v-card>
            <v-card-title style="background: var(--v-primary-base); position: sticky; top: 75px; z-index: 1; color: white !important">
                <v-icon large left style="color: white">mdi-chart-areaspline</v-icon>
                <span class="title font-weight-light">Configuração de Receitas e Despesas dos Projetos</span>
                <v-spacer/>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="GerarRelatorio()" v-on="on"><v-icon>mdi-text-box-check</v-icon></v-btn>
                    </template>
                    <span>Gerar Relatório</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="LimparFiltros()" v-on="on"><v-icon>mdi-eraser</v-icon></v-btn>
                    </template>
                    <span>Limpar</span>
                </v-tooltip>
            </v-card-title>
            <v-card-text class="mt-3">
                <v-form id="form" ref="form" v-model="valid" lazy-validation>
                    <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="filtro.dataInicial" label="Data de Início" :rules="fieldRules" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="filtro.dataInicial" no-title/>
                            </v-menu>
                        </v-col>   
                        <v-col cols="12" sm="6" md="6">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="filtro.dataFinal" label="Data de Início" :rules="fieldRules" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="filtro.dataFinal" no-title/>
                            </v-menu>
                        </v-col>                 
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
    </master-page>
</template>

<script>

export default {
    watch: { 
        
    },
    data: () => ({
        filtro: {            
            dataInicial: null,            
            dataFinal: null,
        },
        valid: true,
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],   

    }),
    methods: {
        GerarRelatorio(){
            if( this.$refs.form.validate()){
                this.AbrirJanela('relatorioReceitasDespesasProjetos')
            }
        },
        LimparFiltros(){
            this.filtro = {
                dataInicial: null,            
                dataFinal: null,
            }
        },
        AbrirJanela(rota) {

            let routeLink = this.$router.resolve({ name: rota,
                query:{
                    dataInicial: this.filtro.dataInicial,
                    dataFinal: this.filtro.dataFinal
                } 
            });
            window.open(routeLink.href,'_blank');
        },
    },
    mounted(){
        
    }
}

</script>